import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsRadioModule,
    CmpsTabsetModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { epicObs } from '../../store';
import { CmpCoachingBlButtonModule } from '../behaviour-library';

import { GoalChartCommitmentModule } from './chart/goal-chart-commitment.module';
import { DialogLayoutService } from './dialog-layout.service';
import { TwoDecimalInputDirective } from './directive/two-decimal-input.directive';
import { ActiveForPerformerGridComponent } from './focus-history/active-for-performer-grid/active-for-performer-grid.component';
import { ActiveForTeamGridComponent } from './focus-history/active-for-team-grid/active-for-team-grid.component';
import { ClosedForPerformerGridComponent } from './focus-history/closed-for-performer-grid/closed-for-performer-grid.component';
import { ClosedForTeamGridComponent } from './focus-history/closed-for-team-grid/closed-for-team-grid.component';
import { FocusHistoryComponent } from './focus-history/focus-history.component';
import { FocusSelectionComponent } from './focus-selection/focus-selection.component';
import { FocusSelectorSetTriggerComponent } from './focus-selector-trigger.component';
import { FocusSelectorComponent } from './focus-selector.component';
import { focusSelectorEpics } from './focus-selector.epic';
import { TranslationIdMap } from './focus-selector.i18n';
import { ExperimentalNgGridModule } from './grid/experimental.ng.grid';
import { ReusableGridModule } from './grid/reusable-grid.module';
import { LoadGoalsComponent } from './load-goals/load-goals.component';
import { MetricSelectionComponent } from './metric-selection/metric-selection.component';
import { FocusSelectionResultComponent } from './selection-result/focus-selection-result.component';

@NgModule({
    imports: [
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
        ExperimentalNgGridModule,
        GoalChartCommitmentModule,
        ReusableGridModule,
        ReactiveFormsModule,
        CmpsDialogModule,
        CmpsRadioModule,
        CmpsCheckboxModule,
        CmpsTabsetModule,
        SelectModule,
        FormsModule,
        CmpsTooltipModule,
        CmpCoachingBlButtonModule,
    ],
    declarations: [
        ActiveForTeamGridComponent,
        ActiveForPerformerGridComponent,
        ClosedForPerformerGridComponent,
        ClosedForTeamGridComponent,
        FocusHistoryComponent,
        FocusSelectionComponent,
        FocusSelectionResultComponent,
        FocusSelectorComponent,
        FocusSelectorSetTriggerComponent,
        LoadGoalsComponent,
        MetricSelectionComponent,
        TwoDecimalInputDirective,
    ],
    exports: [FocusSelectorSetTriggerComponent],
    providers: [DialogLayoutService, DecimalPipe],
})
export class CmpsCoachingFocusSelectorModule {
    constructor() {
        focusSelectorEpics.forEach((e) => epicObs.next(e));
    }
}
